(() => {
  const init = () => {
    const menu = document.querySelector('[data-sl-menu]');
    if (menu && !menu.dataset.ready) {
      const media = window.matchMedia('(min-width: 901px)');
      const sync = () => { menu.open = media.matches; };
      sync(); media.addEventListener('change', sync); menu.dataset.ready = 'true';
    }
    document.querySelectorAll('.sl-nav details').forEach(dropdown => {
      if (dropdown.dataset.ready) return;
      dropdown.dataset.ready = 'true';
      dropdown.addEventListener('toggle', () => {
        if (dropdown.open) document.querySelectorAll('.sl-nav details').forEach(other => { if (other !== dropdown) other.open = false; });
      });
      dropdown.addEventListener('keydown', event => {
        if (event.key === 'Escape') { dropdown.open = false; dropdown.querySelector('summary').focus(); }
      });
    });
    // The menu is rendered by the existing page builder; correct its unit in this theme only.
    if (window.location.pathname === '/pages/the-taproom') {
      const walker = document.createTreeWalker(document.getElementById('MainContent'), NodeFilter.SHOW_TEXT);
      let node; while ((node = walker.nextNode())) { if (node.nodeValue.includes('CITRUS GIN SPRITZ 2ox')) node.nodeValue = node.nodeValue.replace('CITRUS GIN SPRITZ 2ox', 'CITRUS GIN SPRITZ 2oz'); }
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('click', event => { if (!event.target.closest('.sl-nav')) document.querySelectorAll('.sl-nav details[open]').forEach(item => item.open = false); });
})();


(() => {
  const initOccasions = () => {
    document.querySelectorAll('[data-sl-events]').forEach(page => {
      if (page.dataset.ready) return;
      page.dataset.ready = 'true';
      const copy = JSON.parse(page.querySelector('[data-sl-event-copy]').textContent);
      const select = page.querySelector('[data-sl-event-select]');
      const setEvent = (requested, updateUrl = false) => {
        const key = Object.hasOwn(copy, requested) ? requested : 'general';
        const photoKey = key === 'other' ? 'general' : key;
        page.querySelectorAll('[data-sl-event-photo]').forEach(image => { image.hidden = image.dataset.slEventPhoto !== photoKey; });
        page.querySelector('[data-sl-event-heading]').textContent = copy[key].heading;
        page.querySelector('[data-sl-event-intro]').textContent = copy[key].intro;
        page.querySelectorAll('button[data-sl-event]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.slEvent === key)));
        if (select) { const option = [...select.options].find(item => item.dataset.eventKey === key); select.value = option ? option.value : ''; }
        page.dataset.selectedEvent = key;
        if (updateUrl) { const url = new URL(location.href); if (key === 'general') url.searchParams.delete('event'); else url.searchParams.set('event', key); history.replaceState(null, '', url); }
      };
      setEvent(new URL(location.href).searchParams.get('event'));
      page.querySelectorAll('[data-sl-event]').forEach(button => button.addEventListener('click', event => { const key = button.dataset.slEvent; event.preventDefault(); setEvent(key, true); if (key === 'other') page.querySelector('#SLEventType').focus(); }));
      if (select) select.addEventListener('change', () => setEvent(select.selectedOptions[0].dataset.eventKey || 'general', true));
      window.addEventListener('popstate', () => setEvent(new URL(location.href).searchParams.get('event')));
    });
    document.querySelectorAll('[data-sl-keg-shop]').forEach(shop => {
      if (shop.dataset.ready) return;
      shop.dataset.ready = 'true';
      shop.querySelectorAll('[data-sl-keg-size]').forEach(button => button.addEventListener('click', () => {
        const size = button.dataset.slKegSize;
        shop.querySelectorAll('[data-sl-keg-size]').forEach(other => other.setAttribute('aria-pressed', String(other === button)));
        shop.querySelectorAll('[data-sl-keg-card]').forEach(card => { card.hidden = size !== 'all' && card.dataset.slKegCard !== size; });
      }));
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initOccasions); else initOccasions();
  document.addEventListener('shopify:section:load', initOccasions);
})();
